import React from 'react';
import './Footer.css';

function Footer() {

  return (

    <footer>
      <h4>Created By <a href="https://www.tieg.run/">TIEGRUN</a></h4>
    </footer>

  )
}

export default Footer